<template>
    <div class="logo" @click="navigateHome"/>
</template>

<script>
export default {
    name: 'Logo',
    methods: {
        navigateHome() {
            this.$router.push('/')
        }
    }
}
</script>